<div class="d-flex flex-column flex-sm-row input-btn-group mb-2">
  <div class="mb-2 me-sm-2">
    <button
      class="btn btn-primary btn-lg w-100"
      (click)="openAddServiceTypeForm()"
    >
      + Add Service Type
    </button>
  </div>
  @if (initialList?.length > 5) {
    <div class="flex-sm-grow-1">
      <gtapp-auto-complete
        [data]="serviceTypeDropDownList"
        placeHolder="Filter / Search"
        searchKeyword="name"
        [itemTemplate]="serviceTypeTemplate"
        (inputChanged)="onServiceTypeLookup($event)"
        (selected)="openEditServiceTypeForm($event)"
        (submitted)="filterResults($event)"
        [enableSearchCloseOption]="true"
        (fieldCleared)="filterResults('')"
      >
      </gtapp-auto-complete>
      <ng-template #serviceTypeTemplate let-item>
        <div>{{ item?.name }}</div>
      </ng-template>
    </div>
  }
</div>

@if (initialList?.length > 0) {
  <gtapp-card-list
    [mobileCardUIData]="serviceTypeList"
    [mobileCardDetails]="cardDetails"
    [mobileActionIcons]="cardActionIcons"
    [otherParams]="{ paginationData: true }"
    (actionClick)="deleteServiceType($event?.event)"
    (rowClick)="openEditServiceTypeForm($event)"
  ></gtapp-card-list>
}
